import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const GP_Talwar_Young_Scientist_Awards = () => {
  return (
    <div>
      <Header />
      <Navbar />
      <div className="px-4">
        <div className="max-w-7xl mx-auto bg-white p-6 ">
          {/* Header Section */}
          <header className="flex justify-between items-center mb-2 pb-6">
            <h1 className="text-3xl md:text-4xl text-blue-800 ">I.I.S. Awards</h1>

          </header>

          {/* Content Section */}
          <section>
            <h2 className="text-2xl md:text-3xl text-gray-600 mb-4 ">G.P. Talwar Young Scientist Awards</h2>
            <p className="text-md md:text-lg text-gray-600 mb-4">
              The IIS G.P. Talwar Young Scientist Award recognizes outstanding young researchers for their significant contributions in their respective fields. In addition to the certificate, medal, and cash prize, the selected awardees will be invited to present their research findings at Immunocon-2025 organized by MNNIT Allahabad. This platform offers them an excellent opportunity to showcase their work, foster collaborations, and engage with other researchers and experts in the field. The evaluation of the nominations will be carried out by a distinguished committee of professionals, ensuring a fair and transparent selection process. Applicants are encouraged to submit their nominations well before the deadline to ensure smooth processing.</p>

            <p className="text-md md:text-lg text-gray-600 mb-4">

              i. The Award carries a Certificate, a Medal and a Cash prize of Rs.10,000/- each.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">

              ii. The nominations should be submitted on the prescribed form 'Application/Nomination Form for IIS-Awards' before 31st August 2025 through the Head of the Department or through the Research Supervisor of the candidate.

            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
              iii. When emailing, send directly to: indianimmunologysociety2024@gmail.com with CC to kaustuvnayak@gmail.com including the subject as "IIS G.P. Talwar Young Scientist Award".

            </p>
           
            <p>
              For further details, including eligibility and application procedures, please visit the IIS website at  <a href="https://www.indianimmunologysociety.org/" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">click here</a>.
            </p>
          </section>
        </div>
        <div className="bg-gray-100 mt-6 py-4">
          <div className="max-w-7xl mx-auto px-4 text-center">
            
            <p className="text-base mb-6">
              Nomination Form:
              <a
                href="/nomination_form.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>
            <p className="text-base mb-6">
              Guideline:
              <a
                href="/guidelines.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>

          </div>
        </div>
      </div>

    </div>

  )
}

export default GP_Talwar_Young_Scientist_Awards
